export default __webpack_public_path__ + "static/media/drum_two.22899a54.mp3";